import { levels } from '../../../lookups'
import { Body, Box, H4 } from '../'
import { Dialog } from './'

export const TeamLevelDialog = ({ ...props }) => (
  <Dialog {...props} mobileDrawer={false}>
    <H4 color="black">Team level descriptions</H4>
    <Box column gap={8} className="black-scroller" overflowY="auto" maxHeight="50dvh">
      {levels.map(({ name, description }, index) => <Box key={index} column fullWidth alignItems="flex-start">
        <Body color="black" lineHeight="24px" weight={700} >{name}</Body>
        <Body color="black" lineHeight="24px">{description}</Body>
      </Box>)}
    </Box>
  </Dialog>
)